import axios, { AxiosPromise } from 'axios'
import { ErrosRndsInput } from 'view/configuracoes/municipal/rnds/model-rndsErros'

export class Rnds {
  gerarRelatorioErrosRnds(errosRndsInput: ErrosRndsInput): AxiosPromise<Blob> {
    return axios.post('/api/rnds/relatorioErrosCsv', errosRndsInput, { responseType: 'blob' })
  }
}
